import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Components/Home";
import Sidebar from "./Components/Navigation/Sidebar";
import Header from "./Components/Navigation/Header";
import Stepper from "./Components/FaireDemande/Steps/Stepper";
import Datatable from "./Components/Table/DataTable";
import { useLocation, useNavigate } from "react-router-dom";
import DetailPage from "./Pages/DetailPage";
import EnvoiDocumentPage from "./Pages/EnvoiDocumentPage";
import LoginSesamePage from "./Pages/LoginSesamePage";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const params = useLocation();
  const user = window.localStorage.getItem("userData");
  console.log(user);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("user", user);
    if (
      !user &&
      params.pathname != "/login" &&
      params.pathname != "/faire-une-demande" && 
      !params.pathname.includes("completer-une-demande")
    ) {
      navigate("/login");
    }
    if (user && user?.id) {
      navigate("/");
    }
  }, []);

  if (params.pathname == "/login") {
    return (
      <div className="d-flex demandePage justify-content-center">
        <div className="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
          <div className="px-md-5 px-0 mt-1">
            <div className="text-center mt-5 mb-5">
              <img src="/image/LOGO_SESAME3.jpeg" className="w-50" alt="" />
            </div>
            <div></div>
            <Routes>
              <Route path="login" element={<LoginSesamePage />}></Route>
            </Routes>
          </div>
        </div>
      </div>
    );
  }
  
  if (params.pathname == "/faire-une-demande") {
    return (
      <div className="d-flex demandePage justify-content-center">
        <div className="col-12 col-md-10 col-xl-8 text-center box-faire-demande-mobile ">
          <div className="px-sm-5 mt-1 box-faire-demande-mobile">
            <div className="text-center mt-5">
              <img src="/image/LOGO_SESAME3.jpeg" className="w-50 w-sm-50 w-md-50 w-lg-25 w-xl-25" alt="" />
            </div>
            <div className="">
              <h1 className="text-white fs-3 fw-bold fst-italic my-5 ">
                Formulaire d'inscription et de demande
              </h1>
            </div>
            <Routes>
              <Route path="faire-une-demande" element={<Stepper />}></Route>
            </Routes>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex g">
      <div className="col-2 sidebarResponsive ">
        <Sidebar />
      </div>
      <div className="col px-0 app">
        <div className="enteteApp header mb-4 bg-white">
          <Header />
        </div>
        <div className="px-4 px-sm-5 mt-5 contenu">
          <Routes>
            <Route index element={<Home />} />
            <Route path="/" element={<Home />} />
            <Route path="/mon-profile/:name" element={<DetailPage />} />
            <Route path="/details-demande/:name" element={<DetailPage />} />
            <Route path="faire-une-demande" element={<Stepper />}></Route>
            <Route path="list-des-demandes" element={<Datatable />}></Route>
            <Route path="connexion" element={<LoginSesamePage />}></Route>
            
              <Route
                path="completer-une-demande/:email"
                element={<EnvoiDocumentPage />}
              ></Route>
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default App;
